import ApiService from "@/core/services/ApiService";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import { Module, Action, Mutation, VuexModule } from "vuex-module-decorators";
import { normalizeError } from "@/store/helpers/errorHelper";

export interface AccountInfo {
  errors: unknown;
}

@Module({ namespaced: true, name: "AccountModule" })
export default class AccountModule extends VuexModule implements AccountInfo {
  errors = {};

  get getError() {
    const [errorName] = Object.keys(this.errors);
    const error = this.errors[errorName];
    return error;
  }

  @Mutation
  [Mutations.SET_ERROR](errorObj) {
    this.errors = normalizeError(errorObj);
  }

  @Action
  [Actions.CONFIRM_EMAIL](queryData) {
    return ApiService.get(
      `/account/confirm_email?UserId=${
        queryData.userId
      }&Token=${encodeURIComponent(queryData.token)}`
    )
      .then(({ data }) => {
        this.context.commit(Mutations.SET_ERROR, null);
        return data;
      })
      .catch(({ response, message }) => {
        this.context.commit(Mutations.SET_ERROR, { response, message });
      });
  }

  @Action
  [Actions.RESEND_CONFIRMATION_EMAIL](email) {
    const body = {
      Email: email,
    };
    return ApiService.post(`/account/resend_confirmation_email`, body)
      .then(({ data }) => {
        this.context.commit(Mutations.SET_ERROR, null);
        return data;
      })
      .catch(({ response, message }) => {
        this.context.commit(Mutations.SET_ERROR, { response, message });
      });
  }

  @Action
  [Actions.REGISTER](bodyData) {
    return ApiService.post("/account/register", bodyData)
      .then(({ data }) => {
        this.context.commit(Mutations.SET_ERROR, null);
      })
      .catch(({ response, message }) => {
        this.context.commit(Mutations.SET_ERROR, { response, message });
      });
  }

  @Action
  [Actions.FORGOT_PASSWORD](payload) {
    return ApiService.post("/account/forgot_password", payload)
      .then(() => {
        this.context.commit(Mutations.SET_ERROR, null);
      })
      .catch(({ response, message }) => {
        this.context.commit(Mutations.SET_ERROR, { response, message });
      });
  }

  @Action
  [Actions.RESET_PASSWORD](payload) {
    return ApiService.post("/account/reset_password", payload)
      .then(() => {
        this.context.commit(Mutations.SET_ERROR, null);
      })
      .catch(({ response, message }) => {
        this.context.commit(Mutations.SET_ERROR, { response, message });
      });
  }
}
